module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAMtJREFUeNpiYBggwEi2Tv/ZCkAyAIj1gRjE/gDEF6GyExg2pn7Ap52FTEv7gWQBFpkAKH0Aiqlosf/s+UAygdKgZiLRUgdqWEq6xQwM8dRKXKQGtQMO8UZiEhQlFitgETsAtLCB1kGNDRykRxxTDQyYxYwESib0rFOPNY4xg3sBMN4fkGsxKAXvJ8s7G1MZByKoHwxUHA+YxRcoLUAeQEskUhPXAerXx/6z/2MtLgeo5BpaBcioxaMWj1o89C0mtbHnSG5tNGgAQIABAOMQKSyKaLZzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/Facebook-footer.png
// module id = hiOl
// module chunks = 0